export default "__VITE_ASSET__C2fJm1ax__"